import { useRef, useEffect, useState, useMemo, useCallback } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import sanityClient from "../../sanityClient";

export default function HomeBuild() {
  const sliderRef = useRef(null);
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await sanityClient.fetch(`
          *[_type == "homeBuild" && status == "active"]{
              heading,
              content,
              images[] { image { asset-> { url }}, alt}}`);
        setSlides(data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // Memoized slide data for optimization
  const memoizedSlides = useMemo(() => slides, [slides]);

  // Slider settings for smooth performance
  const sliderSettings = useMemo(() => ({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
    lazyLoad: "ondemand",
  }), []);

  // Memoized arrow functions
  const handlePrev = useCallback(() => sliderRef.current?.slickPrev(), []);
  const handleNext = useCallback(() => sliderRef.current?.slickNext(), []);

  if(!memoizedSlides.length) return <div style={{width:"100%", height:"90vh"}}></div>;
  return (
    <section className="home-build">
      <div className="container">
        <div className="row">
          {/* Left - Image Slider */}
          <div className="col-lg-6 col-md-6">
            <div className="buildslide-image">
              {memoizedSlides.length > 0 && (
                <Slider ref={sliderRef} {...sliderSettings}>
                  {memoizedSlides[0]?.images?.map((imageObj, index) => (
                    <img
                      key={index}
                      src={imageObj.image.asset.url}
                      className="img-responsive"
                      alt={imageObj.alt || "Default Alt Text"}
                    />
                  ))}
                </Slider>
              )}
              <img src="/assets/home/white-curve.svg" className="homebuild-shape" alt="shape" loading="lazy" />
              <img src="/assets/home/white-curve.svg" className="homebuild-shape-2" alt="shape" loading="lazy" />
            </div>
          </div>

          {/* Right - Content Slider */}
          <div className="col-lg-6 col-md-6">
            <div className="build-slider">
              {memoizedSlides.map((slide, index) => (
                <div className="buildslide-box" key={index}>
                  <h2 className="heading">{slide.heading}</h2>
                  {slide.content && slide.content.length > 0 ? (
                    slide.content.map((block, idx) => (
                      <p key={idx}>
                        {block.children?.map((child) => child.text).join(" ") || ""}
                      </p>
                    ))
                  ) : (
                    <p>No content available</p>
                  )}
                </div>
              ))}

              {/* Custom Arrow Navigation */}
              <div className="build-arrows">
                <div className="default-arrowleft" onClick={handlePrev}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div className="default-arrowright" onClick={handleNext}>
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
